/*
 * product-gallery-splide.js — ADDITIVE Splide layer for the PRODUCT gallery.
 *
 * Runs ONLY on slider layouts (gallery_layout = 'thumbnail' | 'thumbnail_slider').
 * 'stacked' and '2 columns' => strict NO-OP, native theme code stays 100% untouched.
 *
 * SPLIDE IS THE SOLE SLIDER: the native slider (scroll) is neutralized so it never runs in
 * parallel (no duplication). Everything Splide does NOT own is REUSED from native, not reinvented:
 *   - is-active, video play/pause, thumbnail active+scroll, variant show/hide  => native setActiveMedia
 *   - fullscreen zoom (product-image-zoom.js)                                  => native, works for free
 *   - dots + numeric counter (Splide chrome native no longer drives)          => this engine
 * Coordination: we WRAP the media-gallery instance's setActiveMedia so its slider effect routes to
 * Splide.go(), while its side-effects (is-active/video/thumbnail/filter) still run. User drags/arrows
 * drive Splide, and on 'moved' we call the ORIGINAL setActiveMedia so native side-effects follow.
 *
 * Zero native overwrites: standalone asset + one <script> loader. We never edit media-gallery.js /
 * product-media-gallery.liquid / base.css / secondary.js. Splide = window.Splide (secondary.js => 0 KB).
 * Escape hatch: ?splideoff=1  |  Fail-safe: any error => restoreNative().
 */
(function () {
  'use strict';

  if (/[?&]splideoff=1/i.test(location.search)) return;

  var SLIDER_LAYOUTS = { thumbnail: 1, thumbnail_slider: 1 };
  var SPEED = 400;   // Splide's built-in reducedMotion option overrides this to 0 for prefers-reduced-motion users
  var EASING = 'cubic-bezier(0.25, 1, 0.5, 1)';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function afterSplide(fn, n) {
    n = n || 0;
    if (window.Splide) return fn();
    if (n > 80) return;                              // ~6s ceiling, then give up (native stays)
    setTimeout(function () { afterSplide(fn, n + 1); }, 75);
  }

  // Theme ships Splide's JS but NOT its core CSS; the moved native <li class="product__media-item"> is
  // position:absolute + display:none (native fader/JS) so slides stack -> Splide's drag px->slide math
  // breaks. Inject the minimal Splide layout, scoped to .pg-splide, overriding the native positioning.
  // .splide__list{overflow:visible} is what makes native setActiveMedia's scrollTo a genuine no-op.
  function injectCSS() {
    if (document.getElementById('pg-splide-css')) return;
    var s = document.createElement('style');
    s.id = 'pg-splide-css';
    s.textContent =
      '.pg-splide{position:relative}' +
      '.pg-splide .splide__track{overflow:hidden}' +
      '.pg-splide .splide__list{display:flex;overflow:visible!important;margin:0!important;padding:0!important}' +
      '.pg-splide .splide__slide{display:block!important;position:relative!important;top:auto!important;left:auto!important;right:auto!important;' +
        'flex-shrink:0!important;flex-grow:0;box-sizing:border-box;list-style:none;float:none!important;opacity:1!important;visibility:visible!important;transform:none!important}' +
      '.pg-splide .splide__slide.hidden{display:none!important}' +
      // thumbnail Splide (dual synced): same layout reset; keep native thumb width via fixedWidth
      '.pg-thumb-splide{position:relative;width:100%;max-width:100%;overflow:hidden}' +
      '.pg-thumb-splide .splide__track{overflow:hidden!important;width:100%;max-width:100%;box-sizing:border-box;padding:4px}' +
      '.pg-thumb-splide .splide__list{display:flex;overflow:visible!important;margin:0!important;padding:0!important}' +
      '.pg-thumb-splide .splide__slide{display:block!important;position:relative!important;top:auto!important;left:auto!important;' +
        'flex-shrink:0!important;flex-grow:0;box-sizing:border-box;list-style:none;float:none!important;cursor:pointer}' +
      // keep the theme's .hidden (variant filtering) working on the clones — without this, the
      // display:block!important above (0-2-0) would beat base.css .hidden{display:none!important} (0-1-0)
      '.pg-thumb-splide .splide__slide.hidden{display:none!important}' +
      // VERTICAL (ttb) rail: theme ships Splide JS but not its core CSS, so the ttb list-direction that
      // Splide normally gets from .splide--ttb CSS is absent -> stack the clones in a column ourselves.
      // Splide sets the track height (from the height option) + each slide height (fixedHeight) inline.
      '.pg-thumb-splide--ttb{height:100%;width:100%}' +
      // flex-direction:column stacks the clones; height:100% is CRITICAL — Splide's overflow test for ttb is
      // sliderSize(total slide span) > listSize(the .splide__list box). Left unconstrained the column list
      // grows to its full content height, so listSize == sliderSize and Splide decides it does NOT overflow
      // (go()/drag never scroll). Pinning the list to the track height (content then overflows, track clips)
      // makes listSize the viewport height, so the overflow test passes — exactly how the horizontal list's
      // width is naturally constrained to the track.
      '.pg-thumb-splide--ttb .splide__list{flex-direction:column;height:100%}' +
      '.pg-thumb-splide--ttb .splide__slide{width:100%!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  var INSTANCES = [];   // theme-editor bookkeeping: lets section:load tear down orphaned instances

  function boot() {
    injectCSS();
    var list = document.querySelectorAll('media-gallery[data-desktop-layout]');
    for (var i = 0; i < list.length; i++) {
      try { enhance(list[i]); } catch (e) { /* fail-safe: leave this gallery native */ }
    }
  }

  function enhance(mg) {
    var layout = mg.getAttribute('data-desktop-layout');
    if (!SLIDER_LAYOUTS[layout]) return;             // stacked / columns => native no-op
    if (mg._pgSplide) return;

    var viewer = mg.querySelector('slider-component[id^="GalleryViewer-"]')
              || mg.querySelector('.product-media-slider')
              || mg.querySelector('slider-component');
    if (!viewer) return;
    var ul = viewer.querySelector('ul.product__media-list') || viewer.querySelector('ul');
    if (!ul) return;

    var slides = Array.prototype.slice.call(ul.children).filter(function (n) { return n.nodeType === 1; });
    if (slides.length <= 1) return;                  // single media => native is fine

    // The instance REGISTERS ITSELF (mg._pgSplide + INSTANCES) at the end of build(), and only on
    // success. Assigning here instead would clobber restore()'s `mg._pgSplide = null` on a build
    // failure: `mg._pgSplide = new PGSplide(...)` runs its PutValue AFTER the constructor returns, so
    // the caught-and-restored instance would be written back over the null, leaving a dead instance
    // that blocks the enhance() guard below from ever re-enhancing this gallery (LT-2).
    new PGSplide(mg, viewer, ul, slides, layout);
  }

  /* -------------------------------------------------------------------------- */

  function PGSplide(mg, viewer, ul, slides, layout) {
    this.mg = mg; this.viewer = viewer; this.ul = ul; this.slides = slides; this.layout = layout;
    this.reowned = [];
    this.moved = false;
    this.serverActiveId = null;
    try { this.build(); } catch (e) { this.restore(); }
  }

  PGSplide.prototype.build = function () {
    var self = this;

    // 1) Build the Splide skeleton INSIDE the viewer and MOVE the slides in (moving keeps zoom/video
    //    delegated listeners alive). The <li> stay descendants of the viewer, so native setActiveMedia's
    //    `viewer.querySelector('[data-media-id]')` still finds them => native side-effects keep working.
    var root = document.createElement('div');
    root.className = 'pg-splide splide';
    root.setAttribute('data-pg-splide', '');
    var track = document.createElement('div'); track.className = 'splide__track';
    var list = document.createElement('ul'); list.className = 'splide__list';
    this.slides.forEach(function (li) {
      if (li.classList.contains('is-active')) self.serverActiveId = li.getAttribute('data-media-id');  // capture the server/deep-link featured media
      li.classList.add('splide__slide');
      list.appendChild(li);
    });
    track.appendChild(list); root.appendChild(track);
    this.root = root; this.list = list;

    // 2) Neutralize the native slider WITHOUT editing media-gallery.js: slides are gone from the native
    //    <ul>, so its scroll has nothing to move; hide it. (setActiveMedia's scrollTo also no-ops here.)
    this.ul.style.display = 'none';
    this.ul.setAttribute('aria-hidden', 'true');
    this.ul.parentNode.insertBefore(root, this.ul);
    this.moved = true;

    // 3) Mount Splide (headless: no built-in arrows/pagination — we reuse the native ones).
    var opts = {
      type: 'slide',
      rewind: this.viewer.getAttribute('data-desktop-drag-rewind') === 'true' || this.mg.getAttribute('data-rewind') === 'true',
      drag: true, arrows: false, pagination: false, keyboard: false,
      perPage: 1, perMove: 1, gap: 0, updateOnMove: true,   // focus omitted: inert under perPage:1 (one slide per page)
      speed: SPEED, easing: EASING,
      flickPower: 600, flickMaxPages: 1, dragMinThreshold: { mouse: 0, touch: 10 }, waitForTransition: false
    };
    this.splide = new window.Splide(root, opts);   // NOT mounted yet (throws => caught by build())

    this.wireControls();
    this.buildThumbs();                            // create the thumbnail Splide (NOT mounted yet)

    // syncChrome (dots + counter) only needs the START of a navigation: 'move' already carries the final
    // index, so 'moved' is a redundant second call; 'mounted' fires during mount() below and sets the
    // initial state (wireControls above has already created this.counterCur/this.dots).
    this.splide.on('mounted move', function () { self.syncChrome(); });
    this.splide.mount();
    if (this.thumbSplide) {
      try { this.thumbSplide.mount(); } catch (e) { self._thumbFail(); }
    }

    // 4) Splide-sole coordination: wrap native setActiveMedia + seed the initial media.
    this.coordinate();

    // Register LAST — reached only if every step above succeeded. If build() throws, the constructor's
    // catch runs restore() (which leaves mg._pgSplide null and tears down whatever was built), we never
    // get here, and the gallery stays native + genuinely re-enhanceable. Note (LT-1): on that rare
    // build-error fallback the native prev/next/dot buttons reowned in wireControls() are left inert
    // (their guarded handlers no-op once splide is null) until a later re-enhance (section:load /
    // breakpoint reorient) rewires fresh ones — the rail itself stays swipe/scroll usable meanwhile.
    this.mg._pgSplide = this;
    INSTANCES.push(this);
  };

  /* --- Coordination: Splide owns position; native owns is-active/video/thumbnail/variant ------ */
  PGSplide.prototype.coordinate = function () {
    var self = this, mg = this.mg;
    if (typeof mg.setActiveMedia !== 'function' || mg._pgWrapped) { this.seed(); return; }
    mg._pgWrapped = true;
    mg._pgOrigSAM = mg.setActiveMedia;                       // keep the unbound original for restore()
    var nativeSAM = mg.setActiveMedia.bind(mg);              // does filtering + is-active + video + thumbnail; its scrollTo no-ops on our overflow:visible list
    this.nativeSAM = nativeSAM;

    // Override: keep native side-effects, but drive the SLIDER via Splide (no native scroll).
    mg.setActiveMedia = function (mediaId, prepend, filtering, currentVariant) {
      var doFilter = !!(filtering && currentVariant);
      try { nativeSAM(mediaId, false, doFilter, doFilter ? currentVariant : null); } catch (e) {}   // is-active + video + thumbnail (+ show/hide on variant)
      if (doFilter) { try { self.splide.refresh(); } catch (e) {} }                                  // re-layout after slides shown/hidden
      var idx = self.indexOfMediaId(mediaId);
      if (idx >= 0 && idx !== self.splide.index) {
        mg._ppSelect = self.slides[idx].getAttribute('data-media-id');   // dedup token for the 'moved' below
        self.splide.go(idx);
      }
    };

    // USER drives Splide (drag / arrow / thumbnail) -> native side-effects follow. Skip OUR own go().
    // Hooked on 'move' (fires when the transition STARTS), not 'moved' (when it COMPLETES): measured
    // on 'moved' the thumb rail sat frozen through the full 400ms main animation and then ran its own
    // 400ms catch-up — a serial 800ms sequence during which rail clicks hit moving targets. On 'move'
    // the rail and the is-active/video side-effects animate IN PARALLEL, matching native sync() timing.
    this.splide.on('move', function (newIndex, prevIndex) {
      var i = (typeof newIndex === 'number') ? newIndex : self.splide.index;
      var slide = self.slides[i];
      // Variant filtering leaves display:none slides in Splide's index math (v4 collects slides purely
      // by class) — hop over a hidden landing slide to the nearest visible one instead of showing a gap.
      if (slide && slide.classList.contains('hidden')) {
        var dir = (typeof prevIndex === 'number' && i < prevIndex) ? -1 : 1;
        var j = self.nearestVisible(i, dir);
        if (j >= 0 && j !== i) { try { self.splide.go(j); } catch (e) {} }
        return;
      }
      if (self.thumbSplide) { try { self.thumbSplide.go(i); } catch (e) {} }        // manual sync: scroll the active thumb into view (all moves)
      if (!slide) return;
      var mid = slide.getAttribute('data-media-id'); if (!mid) return;
      var skip = mg._ppSelect === mid;                // programmatic move -> native already ran in the wrapper
      mg._ppSelect = null;                            // ALWAYS clear — a token left by an interrupted go() must not swallow the next real move
      if (skip) return;
      try { nativeSAM(mid, false, false, null); } catch (e) {}                      // real swipe -> update is-active / video / thumbnail (scroll no-ops)
    });

    this.seed();
  };

  // Open on the server's featured media (or first) — ONE wrapped call, deterministic, no pin/timers.
  PGSplide.prototype.seed = function () {
    var id = this.serverActiveId || (this.slides[0] && this.slides[0].getAttribute('data-media-id'));
    if (!id) return;
    try { this.mg.setActiveMedia(id); } catch (e) {}
  };

  /* --- Arrows / dots / counter: reuse native DOM, drive via Splide.go (moved -> native effects) -- */
  PGSplide.prototype.wireControls = function () {
    var self = this;
    // Leave the .slider-buttons cluster where it is (absolutely positioned overlay). Moving it INTO the
    // .splide root makes mount() throw. Just reown (clone strips native listeners) + drive in place.
    var cluster = this.viewer.querySelector('.slider-buttons');
    var scope = cluster || this.viewer;

    this.reownAll(scope.querySelectorAll('button[name="previous"], .slider-button--prev'), function () { if (self.splide) self.splide.go('<'); });
    this.reownAll(scope.querySelectorAll('button[name="next"], .slider-button--next'), function () { if (self.splide) self.splide.go('>'); });

    this.dots = Array.prototype.slice.call(scope.querySelectorAll('.slider-counter__link, button.slider-counter__link, [data-media-position]'))
      .map(function (dot, i) { return self.reown(dot, function () { if (self.splide) self.splide.go(i); }); });   // keep the CLONES — reown() replaces the originals in the DOM, so syncChrome must target the clones

    this.counterCur = scope.querySelector('.slider-counter--current');
    this.counterTot = scope.querySelector('.slider-counter--total');
    if (this.counterTot) this.counterTot.textContent = String(this.slides.length);
  };

  /* --- Thumbnails: a SECOND Splide synced to the main MANUALLY (no isNavigation/sync(), see note
       below) => dual synced slider. Splide owns thumb drag + scroll-active-into-view; clicking a
       thumb moves the main via go(). We clone the thumb <li> (strips the native click listener bound
       to the original setActiveMedia) so navigation flows through ONE path only. If it fails, restore
       the native rail. */
  PGSplide.prototype.buildThumbs = function () {
    var self = this;
    var navMain = false;   // setting: thumbnail-rail arrows drive the MAIN gallery (+ center the active thumb)
    try { navMain = (window.__pgThumbNav || {})[this.mg.getAttribute('data-section')] === true; } catch (e) {}
    var comp = this.mg.querySelector('slider-component[id^="GalleryThumbnails-"]');
    if (!comp || !window.Splide) return;
    var ul = comp.querySelector('ul.thumbnail-list') || comp.querySelector('ul');
    if (!ul) return;
    var items = Array.prototype.slice.call(ul.children).filter(function (n) { return n.nodeType === 1 && n.hasAttribute && n.hasAttribute('data-target'); });
    if (items.length <= 1) return;

    // Measure the native thumb size BEFORE moving, so the Splide slides keep the native width/gap.
    var r0 = items[0].getBoundingClientRect();
    var thumbW = Math.round(r0.width) || 0;
    var thumbH = Math.round(r0.height) || 0;
    // Orientation from the SERVER-set layout class (deterministic), NOT from measuring thumb positions.
    // Measuring positions is racy: during an early reflow the thumbnails can be momentarily STACKED (full
    // width, before their horizontal CSS settles), which read as "vertical" and built a ttb rail for a
    // BOTTOM strip — full-width slides stacked in a column with horizontal arrows. The class reflects the
    // true layout at the current viewport (desktop uses the desktop-* class, mobile the mobile-* one).
    var vertical = false;
    try {
      vertical = window.matchMedia('(min-width: 750px)').matches
        ? this.mg.classList.contains('media-gallery--desktop-thumbnails-vertical')
        : this.mg.classList.contains('media-gallery--mobile-thumbnails-vertical');
    } catch (e) {}
    var gap = 8;
    if (items[1]) {
      var r1 = items[1].getBoundingClientRect();
      var g = Math.round(vertical ? (r1.top - r0.bottom) : (r1.left - r0.right));
      if (g >= 0 && g < 60) gap = g;
    }
    // Guard against a raced/degenerate size read (thumbnails measured at full container width before their
    // CSS applied): drop to Splide auto-sizing rather than pinning a wrong fixedWidth/fixedHeight.
    var railW = 0; try { railW = Math.round(comp.getBoundingClientRect().width); } catch (e) {}
    if (thumbW && railW && thumbW > railW * 0.7) { thumbW = 0; thumbH = 0; }
    // Build a Splide thumbnail rail for BOTH orientations: horizontal uses fixedWidth; VERTICAL (thumbnails
    // position left/right) uses Splide's native direction:'ttb' + height (viewport = main-image height) +
    // fixedHeight. Native vertical mode keeps the rail on the SAME drag/arrow/sync path as the horizontal
    // one instead of patching the theme's incomplete native vertical CSS.
    this.thumbVertical = vertical;

    var root = document.createElement('div'); root.className = 'pg-thumb-splide splide' + (vertical ? ' pg-thumb-splide--ttb' : '');
    var track = document.createElement('div'); track.className = 'splide__track';
    var list = document.createElement('ul'); list.className = 'splide__list';
    items.forEach(function (li, idx) {
      var clone = li.cloneNode(true);      // clone strips the native constructor-bound click listener
      clone.classList.add('splide__slide');
      clone.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (self.splide) self.splide.go(idx); });  // manual sync: click thumb -> main
      list.appendChild(clone);
    });
    track.appendChild(list); root.appendChild(track);
    ul.style.display = 'none'; ul.setAttribute('aria-hidden', 'true');
    // ORDER IS LOAD-BEARING: the clone rail must sit BEFORE the hidden native ul inside the same
    // slider-component — media-gallery.js setActiveThumbnail uses querySelector('[data-target=...]'),
    // which returns the FIRST match, i.e. our visible clone. That is what keeps aria-current (the
    // theme's active-thumb ring) on the visible rail. Do not move this insertion point.
    ul.parentNode.insertBefore(root, ul);
    this.thumbRoot = root; this.thumbUl = ul;

    // Manual sync (thumb click -> main.go; main 'move' -> thumb.go) instead of native sync()/isNavigation.
    // NOTE: the bundled Splide's native sync() was VERIFIED WORKING — manual sync is KEPT for two real
    // reasons: (1) isNavigation would put role/tabindex on the clone <li> around the theme's own
    // <button> thumbs (nested interactive controls), and (2) the theme highlights the active thumb via
    // aria-current on its own button (see the ORDER note above) — Splide's is-active class would not
    // drive that styling. navMain is NOT a reason: reowned arrows call main.go() under either scheme.
    var opts = {
      arrows: false, pagination: false, drag: true, keyboard: false,
      gap: gap, focus: navMain ? 'center' : 0, rewind: false, updateOnMove: false,   // focus kept: meaningful here (fixedWidth/fixedHeight => many slides/page)
      speed: SPEED, easing: EASING
    };
    if (vertical) {
      opts.direction = 'ttb';
      opts.height = this._thumbRailHeight();       // px viewport height = main-image height (kept in sync below; Splide's ttb needs a px height, not %)
      opts.padding = { top: 6, bottom: 6 };
      if (thumbH) opts.fixedHeight = thumbH; else opts.autoHeight = true;
    } else {
      opts.padding = 6;
      if (thumbW) opts.fixedWidth = thumbW; else opts.autoWidth = true;
    }

    try { this.thumbSplide = new window.Splide(root, opts); }   // created only; sync + mount happen in build()
    catch (e) { this._thumbFail(); return; }
    if (vertical) this._observeThumbHeight();       // ResizeObserver: keep the ttb viewport height matched to the main image (late image load / resize)

    // Wire the thumbnail rail's own prev/next arrows. Setting window.__pgThumbNav[section]:
    //   ON  -> arrows NAVIGATE the MAIN gallery (prev/next), so the selected image + thumbnail always follow
    //          (the 'moved' handler scrolls the active thumb into view, so it never drifts off-screen);
    //   OFF -> arrows just SCROLL the thumbnail strip (theme default). reown clones (strips native listeners).
    if (navMain) {
      this.reownAll(comp.querySelectorAll('button[name="previous"], .slider-button--prev'), function () { if (self.splide) self.splide.go('<'); });
      this.reownAll(comp.querySelectorAll('button[name="next"], .slider-button--next'), function () { if (self.splide) self.splide.go('>'); });
    } else if (this.thumbSplide) {
      this.reownAll(comp.querySelectorAll('button[name="previous"], .slider-button--prev'), function () { try { self.thumbSplide.go('<'); } catch (e) {} });
      this.reownAll(comp.querySelectorAll('button[name="next"], .slider-button--next'), function () { try { self.thumbSplide.go('>'); } catch (e) {} });
    }
  };

  // Thumb Splide failed -> tear it down and bring the native thumbnail rail back (main still works).
  PGSplide.prototype._thumbFail = function () {
    try { if (this._thumbRO) { this._thumbRO.disconnect(); this._thumbRO = null; } } catch (e) {}
    try { if (this.thumbSplide) this.thumbSplide.destroy(true); } catch (e) {}
    try { if (this.thumbUl) { this.thumbUl.style.display = ''; this.thumbUl.removeAttribute('aria-hidden'); } } catch (e) {}
    try { if (this.thumbRoot && this.thumbRoot.parentNode) this.thumbRoot.parentNode.removeChild(this.thumbRoot); } catch (e) {}
    this.thumbSplide = null; this.thumbRoot = null;
  };

  // Vertical (ttb) rail viewport height = the main image height. The .thumbnail-slider wrapper is placed
  // beside the main image (position:absolute; top:0; bottom:0 -> media-gallery height) by the section CSS,
  // so its measured height is what the ttb Splide needs. Fallbacks: the main viewer height, then 400px.
  PGSplide.prototype._thumbRailHeight = function () {
    var h = 0;
    try { var wrap = this.thumbRoot && this.thumbRoot.parentNode; if (wrap) h = Math.round(wrap.getBoundingClientRect().height); } catch (e) {}
    if (!h || h < 80) { try { h = Math.round(this.viewer.getBoundingClientRect().height); } catch (e) {} }
    return (h && h > 80) ? h : 400;
  };

  // Splide's ttb height must be an explicit px value (it does not accept %), so it cannot auto-track the
  // main image the way the horizontal rail's width:100% does. Watch the wrapper and push a fresh height on
  // change (responsive breakpoints, late image load, variant swaps that resize the main image).
  PGSplide.prototype._observeThumbHeight = function () {
    var self = this;
    var target = (this.thumbRoot && this.thumbRoot.parentNode) || this.viewer;
    if (!target || typeof ResizeObserver === 'undefined') return;
    this._lastThumbH = this._thumbRailHeight();
    this._thumbRO = new ResizeObserver(function () {
      if (!self.thumbSplide) return;
      var h = self._thumbRailHeight();
      if (h && Math.abs(h - (self._lastThumbH || 0)) > 4) { self._lastThumbH = h; try { self.thumbSplide.options = { height: h }; } catch (e) {} }
    });
    try { this._thumbRO.observe(target); } catch (e) {}
  };

  // Nearest slide not hidden by variant filtering, searching dir first then the opposite side.
  PGSplide.prototype.nearestVisible = function (from, dir) {
    var n = this.slides.length;
    for (var step = 1; step < n; step++) {
      var a = from + dir * step, b = from - dir * step;
      if (a >= 0 && a < n && !this.slides[a].classList.contains('hidden')) return a;
      if (b >= 0 && b < n && !this.slides[b].classList.contains('hidden')) return b;
    }
    return -1;
  };

  PGSplide.prototype.indexOfMediaId = function (mediaId) {
    for (var i = 0; i < this.slides.length; i++) {
      var id = this.slides[i].getAttribute('data-media-id') || (this.slides[i].dataset ? this.slides[i].dataset.mediaId : '');
      if (id && (id === mediaId || id.indexOf('-' + mediaId) >= 0 || id.split('-').pop() === String(mediaId))) return i;
    }
    return -1;
  };

  /* --- Splide chrome ONLY (dots + numeric counter). is-active/video/thumbnail are native now. ------ */
  PGSplide.prototype.syncChrome = function () {
    var i = this.splide ? this.splide.index : 0;
    if (this.counterCur) this.counterCur.textContent = String(i + 1);
    if (this.dots) this.dots.forEach(function (dot, di) {
      if (!dot) return;
      dot.classList.toggle('slider-counter__link--active', di === i);   // the theme's real active-dot styling hook (base.css keys on this class, not aria-current)
      if (di === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
    });
  };

  /* --- reown: clone+replace strips the native SliderComponent's listeners, then bind ours ---------- */
  PGSplide.prototype.reown = function (el, onClick) {
    if (!el || !el.parentNode) return;
    var clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    if (clone.disabled) clone.disabled = false;
    clone.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onClick(); });
    this.reowned.push(clone);
    return clone;
  };
  PGSplide.prototype.reownAll = function (nodeList, onClick) {
    var self = this;
    Array.prototype.forEach.call(nodeList, function (el) { self.reown(el, onClick); });
  };

  /* --- Fail-safe: put everything back exactly as native had it ------------------------------------- */
  PGSplide.prototype.restore = function () {
    try { this._thumbFail(); } catch (e) {}                       // tear down the thumb Splide (clones) + un-hide native rail
    try { if (this.splide) this.splide.destroy(true); } catch (e) {}
    this.splide = null;                                           // reowned arrow/dot handlers no-op after teardown (guarded by `if (self.splide)`)
    try { if (this.mg && this.mg._pgWrapped && this.mg._pgOrigSAM) { this.mg.setActiveMedia = this.mg._pgOrigSAM; this.mg._pgWrapped = false; } } catch (e) {}
    try {
      if (this.moved && this.ul && this.list) {
        var kids = Array.prototype.slice.call(this.list.children);
        kids.forEach(function (li) { li.classList.remove('splide__slide'); });
        for (var k = 0; k < kids.length; k++) this.ul.appendChild(kids[k]);
        this.ul.style.display = '';
        this.ul.removeAttribute('aria-hidden');
      }
      if (this.root && this.root.parentNode) this.root.parentNode.removeChild(this.root);
    } catch (e) {}
    if (this.mg) this.mg._pgSplide = null;
  };

  // Theme editor: a section re-render replaces the DOM without re-running section-embedded scripts,
  // so the fresh gallery would silently stay native and the discarded Splide instances would keep
  // their window resize/matchMedia bindings (pinning detached DOM). Re-enhance + tear down orphans.
  // Editor-only: storefront navigation never fires shopify:section:load.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      afterSplide(function () {
        for (var i = INSTANCES.length - 1; i >= 0; i--) {
          if (!INSTANCES[i].mg || !INSTANCES[i].mg.isConnected) {
            try { INSTANCES[i].restore(); } catch (err) {}
            INSTANCES.splice(i, 1);
          }
        }
        injectCSS();
        var list = (e.target || document).querySelectorAll('media-gallery[data-desktop-layout]');
        for (var k = 0; k < list.length; k++) { try { enhance(list[k]); } catch (err) {} }
      });
    });
    // Deleting/hiding the section in the editor fires shopify:section:unload (with NO following
    // section:load), which the orphan sweep above never sees — the instance + its ResizeObserver would
    // then retain detached DOM for the rest of the editor session. Tear down instances in the unloaded
    // section (or any already detached). Editor-only.
    document.addEventListener('shopify:section:unload', function (e) {
      for (var i = INSTANCES.length - 1; i >= 0; i--) {
        var inst = INSTANCES[i];
        if (!inst.mg || !inst.mg.isConnected || (e.target && e.target.contains && e.target.contains(inst.mg))) {
          try { inst.restore(); } catch (err) {}
          INSTANCES.splice(i, 1);
        }
      }
    });
  }

  // Viewport crossing the desktop/mobile breakpoint (750px): the thumbnail rail's orientation (ttb vs
  // horizontal) is baked at build time, but a merchant can set DIFFERENT desktop vs mobile thumbnail
  // positions (e.g. Left on desktop, Bottom on mobile). Without this, resizing across 750px in-session
  // (window resize, tablet/foldable rotation, split-screen) flips the CSS layout but leaves the Splide
  // rail in its old orientation until a reload. Re-evaluate each live instance from its CURRENT class and
  // rebuild ONLY the ones whose orientation actually flipped (a no-op when desktop==mobile orientation).
  if (typeof window.matchMedia === 'function') {
    var mql750 = window.matchMedia('(min-width: 750px)');
    var reorientTimer;
    var reorient = function () {
      for (var i = INSTANCES.length - 1; i >= 0; i--) {
        var inst = INSTANCES[i];
        if (!inst.mg || !inst.mg.isConnected) continue;
        var want = mql750.matches
          ? inst.mg.classList.contains('media-gallery--desktop-thumbnails-vertical')
          : inst.mg.classList.contains('media-gallery--mobile-thumbnails-vertical');
        if (want === inst.thumbVertical) continue;   // orientation unchanged -> leave the rail as is
        var mg = inst.mg;
        try { inst.restore(); } catch (e) {}          // restore() nulls mg._pgSplide so enhance() rebuilds
        INSTANCES.splice(i, 1);
        try { enhance(mg); } catch (e) {}
      }
    };
    var onBreakpoint = function () { clearTimeout(reorientTimer); reorientTimer = setTimeout(reorient, 160); };
    if (mql750.addEventListener) mql750.addEventListener('change', onBreakpoint);
    else if (mql750.addListener) mql750.addListener(onBreakpoint);   // older Safari
  }

  // Kick off LAST — after every PGSplide.prototype.* method is defined. A deferred script runs with
  // document.readyState !== 'loading', so onReady() invokes boot() SYNCHRONOUSLY; if this ran before the
  // prototype assignments, this.build would be undefined ("this.build is not a function").
  onReady(function () { afterSplide(boot); });
})();
